import type { TLoansCustomerPledgeAutoData } from 'shared/types/TLoansService';

import type { TPledgeAutoFields } from '../types';

export const formDataToLoansCustomerPledgeAutoAdapter = (
  formData?: TPledgeAutoFields,
): TLoansCustomerPledgeAutoData | undefined => {
  if (!formData) {
    return undefined;
  }

  return {
    isOwner: formData.isOwner,
    brand: formData.carBrand?.label,
    model: formData.carModel?.label,
    power: Number(formData.enginePower?.value),
    regNumber: String(formData.carNumber).replace(/\s+/g, ''),
    year: Number(formData.carManufactureYear?.value),
  };
};
